var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8284",
    "data-name": "Path 8284",
    d: "M17,6H15V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6H7A2.006,2.006,0,0,0,5,8V19a2.006,2.006,0,0,0,2,2,1,1,0,0,0,2,0h6a1,1,0,0,0,2,0,2.006,2.006,0,0,0,2-2V8A2.006,2.006,0,0,0,17,6ZM8.75,18h0A.755.755,0,0,1,8,17.25V9.75A.755.755,0,0,1,8.75,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,8.75,18ZM12,18h0a.755.755,0,0,1-.75-.75V9.75A.755.755,0,0,1,12,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,12,18ZM13.5,6h-3V3.5h3Zm1.75,12h0a.755.755,0,0,1-.75-.75V9.75A.755.755,0,0,1,15.25,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,15.25,18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushimeIcon);
export default __webpack_public_path__ + "static/media/pushime_icon.45d70da957abfa9665c52cc90283fe80.svg";
export { ForwardRef as ReactComponent };